import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ContactInstitution } from './ContactInstitution';
import { api, ReadAs } from '../api';
import { Routes, Translatable } from '../_generatedTypes.g';
import { DocumentTitle } from './DocumentTitle';
import { getTranslator } from '../Translator';
import { panicStateSet } from '../features/innerState/innerStateSlice';
import { useAppSelector } from '../hooks';

export const EmailLoginForm = () => {
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    const [message, setMessage] = useState<Translatable>();

    const language = useAppSelector(state => state.language);
    const token = useAppSelector(state => state.clientState.RequestVerificationToken);
    const apiInstance = api(token);

    const t = getTranslator(language);
    const dispatch = useDispatch();

    const login = async () => {
        setSubmitting(true);
        const body = new FormData();
        body.append('email', email);
        await apiInstance.User.SendLoginLink<void>(body)
            .ok((message) => { setMessage(message); setSubmitting(false) }, ReadAs.Json)
            .anyStatus((_, response) => {
                throw new Error(`${Routes.User.SendLoginLink} failed with status code ${response.status}`);
            })
            .fail(() => dispatch(panicStateSet()))
    }

    if (submitting) {
        return <div>{t['Sending log-in link...']}</div>
    }
    return <div>
        <DocumentTitle title={t['Welcome to the elections!']} />
        <p className="login-welcome-title">{t['Welcome to the elections!']}</p>
        <p className="login-use-button">{t['Use your email address to log in.']}</p>
        <form className="passwordlogin" onSubmit={e => { e.preventDefault(); login(); }}>
            {message ? <div className="passwordlogin__statusbanner statusbanner--warning">{t.translate(message)}</div> : null}
            <label>
                {t['Email address']}<input id="EmailLoginForm-Email" name="email" type="email" required={true} onChange={e => setEmail(e.target.value)} />
            </label>
            <div className="buttonrow">
                <button id="EmailLoginForm-Submit" type="submit" className="button--important">{t['Send log-in link']}</button>
            </div>
            <ContactInstitution title={'If you are unable to log in, please contact us via'} />
        </form></div>;
}
